var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible1,
            "close-on-click-modal": false,
            title: "添加模块",
            width: "1280px",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "模块选择:", prop: "moduleVal" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: {
                            placeholder: "请选择模块",
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.changeIt },
                          model: {
                            value: _vm.ruleForm.moduleVal,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "moduleVal", $$v)
                            },
                            expression: "ruleForm.moduleVal",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.componentCode,
                            attrs: {
                              label: item.componentName,
                              value: item.componentCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.sonList.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "选择模块类型:" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start",
                                "flex-wrap": "wrap",
                              },
                            },
                            _vm._l(_vm.sonList, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  class:
                                    item.componentCode === _vm.sonCode
                                      ? "act-div"
                                      : "",
                                  staticStyle: {
                                    margin: "8px 8px 0 0",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sonClick(item)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { display: "block" },
                                    attrs: { src: item.picUrl },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }